@if (fields && query) {
  <div class="wire-query-builder query-builder">
    <wire-rule-set [ruleSet]="query" (ruleSetChange)="ruleSetChanged($event)" [fields]="fields"
                   [allowRemoveRuleSet]="false" [isQueryBuilder]="true"></wire-rule-set>
  </div>
}
